import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuthStatus, selectMustChangePassword } from '../features/auth/authSlice';

/**
 * By the time any route renders, App.jsx's useAuthBootstrap has already
 * resolved (it gates the whole app behind a spinner first) — so this only
 * needs to check the result, not fetch anything itself.
 *
 * RBAC is enforced server-side (every protected endpoint re-checks the
 * bearer token and role) — this guard only improves UX by not flashing
 * protected UI. Never treat this as the security boundary.
 */
export default function ProtectedRoute() {
  const location = useLocation();
  const status = useSelector(selectAuthStatus);
  const mustChangePassword = useSelector(selectMustChangePassword);

  if (status !== 'authenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // While must_change_password is set, the API rejects every protected
  // endpoint except /auth/change-password and /auth/logout with 403 —
  // so there's no point letting the user navigate anywhere else.
  if (mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return <Outlet />;
}
